export const COMMON_DATA_LIST_EVENTS_ERROR = 'COMMON_DATA_LIST_EVENTS_ERROR';
export const COMMON_DATA_LIST_EVENTS_LOADING_SUCCESS = 'COMMON_DATA_LIST_EVENTS_LOADING_SUCCESS';
export const COMMON_DATA_LIST_EVENTS_START_LISTENING_FOR_WS_UPDATES = 'COMMON_DATA_LIST_EVENTS_START_LISTENING_FOR_WS_UPDATES';
